module.exports = __webpack_public_path__ + "img/minus-purple-circle.de352285.svg";